import { render, staticRenderFns } from "./service_card_detail.vue?vue&type=template&id=067b6a50&scoped=true"
import script from "./service_card_detail.vue?vue&type=script&lang=js"
export * from "./service_card_detail.vue?vue&type=script&lang=js"
import style0 from "./service_card_detail.vue?vue&type=style&index=0&id=067b6a50&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b6a50",
  null
  
)

export default component.exports